import React from 'react'
import Intro from '../assets/intro.jpg'

function intro() {
    return (
        <div>
            <section id="intro" style={{paddingBottom:'50px', paddingTop:'50px'}}>
  <div class="container">
    <div class="row g-5 align-items-start align-items-center">
      <div class="col-lg-5">
        <div class="section-label" style={{color:'white'}}>Company Overview</div>
        <h2 class="section-title" style={{color:'white'}}>Nexora<br/><em>Systems</em></h2>
        <div class="divider-gold"></div>
        <p class="intro-body" style={{color:'white'}}>
      Businesses have more data, software, and digital workflows than ever before. Yet much of that information remains fragmented across applications, spreadsheets, emails, and disconnected systems.

Nexora Systems is building an AI-powered operations platform designed to bring those systems together.
        </p>
        <p class="intro-body" style={{marginTop:'16px', color:'white'}}>


Our platform enables businesses to connect their existing software, automate repetitive processes, surface actionable insights, and deploy intelligent AI agents across critical business functions—all through a unified technology layer.

Rather than asking businesses to replace the systems they already use, Nexora is designed to work alongside them.

Our long-term vision is to become the intelligent operating layer between a company's people, data, and software.

Nexora is initially targeting growing businesses that have outgrown manual processes but lack the resources or technical infrastructure required to build sophisticated automation internally. As our platform expands, we intend to move further upstream into larger organizations with increasingly complex operational requirements.
        </p>
      </div>
              <div class="col-lg-7 text-center"
              
                >
        <p class="intro-lead fade-up " style={{marginTop:'26px', color:'white'}}>
           "Nexora has demonstrated that AI can be more than a buzzword—it can become a meaningful part of how a business operates. Their platform has the potential to address a significant and growing need for companies looking to automate processes, improve productivity, and get more value from the technology they already have. We believe Nexora is building a platform with substantial long-term potential, and that’s why we’re excited to support the company as it enters its next stage of growth."
        </p>
                <small class="text-center " style={{ color: 'white'}}><em >Michael Reynolds</em></small>
                <div className='text-center mt-4'>
                  <img src={Intro}/>
                </div>
        {/* <div class="intro-pillars fade-up">
          <div class="pillar">
            <div class="pillar-icon"><i class="fa fa-building-columns"></i></div>
            <h5>Institutional Standards</h5>
            <p>Every company undergoes rigorous due diligence aligned with our criteria.</p>
          </div>
          <div class="pillar">
            <div class="pillar-icon"><i class="fa fa-shield-halved"></i></div>
            <h5>Capital Preservation</h5>
            <p>Senior debt structures and conservative LTV ratios protect downside in all market conditions.</p>
          </div>
          <div class="pillar">
            <div class="pillar-icon"><i class="fa fa-chart-line"></i></div>
            <h5>Value Creation</h5>
            <p>Active asset management and strategic repositioning unlock latent value across every acquisition.</p>
          </div>
        </div>  */}
        {/* <div class="text-center mt-3">
        <img src="./assets/epa.png"/>
        </div> */}
      </div>
    </div>
  </div>
</section>
        </div>
    )
}

export default intro